// LUMINA · pages/vajra/components/MeritBoard.jsx
// Phase 74: 圆满功德榜 — 展示已完成的集体供养项目（佛塔认捐等）
import React, { useState, useEffect } from 'react';
import { API, GD, GDL, TXT, TXT2 } from '../constants';

const PANEL = "rgba(253,251,247,0.96)";
const SAGA_DAWA = "rgba(212,175,55,0.1)";

// ── Lightbox ──
function Lightbox({ src, onClose }) {
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 2000, background: "rgba(0,0,0,0.85)",
      display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out", padding: 20,
    }}>
      <img src={src} alt="" style={{ maxWidth: "90vw", maxHeight: "85vh", objectFit: "contain", borderRadius: 8 }} />
      <button onClick={onClose} style={{
        position: "absolute", top: 20, right: 20, background: "rgba(255,255,255,0.15)",
        border: "none", color: "#fff", fontSize: 28, width: 44, height: 44, borderRadius: "50%", cursor: "pointer",
      }}>✕</button>
    </div>
  );
}

// ── Single Project Card ──
function ProjectCard({ project }) {
  const [showDonors, setShowDonors] = useState(false);
  const [lightbox, setLightbox] = useState(null);

  const donors = project.donor_list || [];
  const receipts = project.receipt_images || [];
  const gallery = project.gallery_images || [];
  const isSagaDawa = project.completed_date && project.completed_date.startsWith("2026-05");

  return (
    <div style={{
      background: PANEL, borderRadius: 12, border: "1px solid rgba(212,175,55,0.18)",
      marginBottom: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    }}>
      {lightbox && <Lightbox src={lightbox} onClose={() => setLightbox(null)} />}

      {/* Cover image */}
      {project.cover_image_url && (
        <img src={project.cover_image_url} alt={project.title_zh}
          onClick={() => setLightbox(project.cover_image_url)}
          style={{ width: "100%", maxHeight: 180, objectFit: "cover", cursor: "zoom-in" }}
          onError={e => { e.currentTarget.style.display = "none"; }} />
      )}

      <div style={{ padding: "16px 18px" }}>
        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
          <span style={{ fontSize: 18 }}>🛕</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: TXT, letterSpacing: ".5px" }}>
              {project.title_zh}
            </div>
            {project.temple_name && (
              <div style={{ fontSize: 11, color: GDL }}>{project.temple_name}</div>
            )}
          </div>
          {isSagaDawa && (
            <div style={{
              fontSize: 10, padding: "2px 10px", borderRadius: 10,
              background: "linear-gradient(135deg,#D4AF37,#B8860B)", color: "#fff",
              letterSpacing: 1, fontWeight: 600,
            }}>
              🟡 萨嘎达瓦
            </div>
          )}
        </div>

        {/* Description */}
        {project.description_zh && (
          <div style={{ fontSize: 12, color: TXT2, lineHeight: 1.8, marginBottom: 12 }}>
            {project.description_zh}
          </div>
        )}

        {/* Completion date + donor count */}
        <div style={{ display: "flex", gap: 16, marginBottom: 10, fontSize: 12 }}>
          {project.completed_date && (
            <span style={{ color: TXT2 }}>
              📅 圆满日期：{project.completed_date}
            </span>
          )}
          {project.total_donors > 0 && (
            <span style={{ color: GD, fontWeight: 600 }}>
              🪷 {project.total_donors} 位功德主
            </span>
          )}
        </div>

        {/* Donor list toggle */}
        {donors.length > 0 && (
          <div style={{ marginBottom: 10 }}>
            <button onClick={() => setShowDonors(!showDonors)} style={{
              background: "none", border: "none", cursor: "pointer", padding: 0,
              fontSize: 12, color: GD, letterSpacing: ".5px",
            }}>
              📜 功德芳名 {showDonors ? "▲" : "▼"}
            </button>
            {showDonors && (
              <div style={{
                marginTop: 8, padding: "10px 14px",
                background: "rgba(212,175,55,0.06)", borderRadius: 8,
                border: "1px solid rgba(212,175,55,0.15)",
              }}>
                {donors.map((d, i) => (
                  <div key={i} style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "4px 0", borderBottom: i < donors.length - 1 ? "1px solid rgba(212,175,55,0.08)" : "none",
                    fontSize: 12, color: TXT,
                  }}>
                    <span>
                      {d.item && <span style={{ color: GDL, marginRight: 6 }}>{d.item}</span>}
                      <strong>{(d.name||'').trim().split(/\s+/).length > 1 
                        ? d.name.trim().split(/\s+/).pop() 
                        : ((d.name||'')[0]||'')}</strong>
                      {(d.name||'').length > 1 && <span style={{ fontSize: 10, color: TXT2, marginLeft: 2 }}>◌</span>}
                    </span>
                    {d.dedication && (
                      <span style={{ fontSize: 10, color: TXT2, fontStyle: "italic" }}>
                        {d.dedication}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Receipt images */}
        {receipts.length > 0 && (
          <div>
            <div style={{ fontSize: 11, color: TXT2, marginBottom: 6, letterSpacing: ".5px" }}>
              🧾 寺庙收据
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {receipts.map((url, i) => (
                <img key={i} src={url} alt={`收据 ${i + 1}`}
                  onClick={() => setLightbox(url)}
                  style={{
                    width: 80, height: 60, objectFit: "cover", borderRadius: 6,
                    cursor: "zoom-in", border: "1px solid rgba(212,175,55,0.2)",
                  }}
                  onError={e => { e.currentTarget.style.display = "none"; }} />
              ))}
            </div>
          </div>
        )}

        {/* Gallery images */}
        {gallery.length > 0 && (
          <div style={{ marginTop: 10 }}>
            <div style={{ fontSize: 11, color: TXT2, marginBottom: 6, letterSpacing: ".5px" }}>
              📸 活动照片
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {gallery.map((url, i) => (
                <img key={i} src={url} alt={`照片 ${i + 1}`}
                  onClick={() => setLightbox(url)}
                  style={{
                    width: 100, height: 75, objectFit: "cover", borderRadius: 6,
                    cursor: "zoom-in", border: "1px solid rgba(212,175,55,0.2)",
                  }}
                  onError={e => { e.currentTarget.style.display = "none"; }} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Main MeritBoard ──
export default function MeritBoard({ maxItems }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/vajra/merit-projects`)
      .then(r => r.ok ? r.json() : [])
      .then(d => { setProjects(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "12px 0" }}>
        <span style={{ fontSize: 12, color: "#ccc" }}>加载中...</span>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "12px 0" }}>
        <span style={{ fontSize: 12, color: "#ccc" }}>暂无功德记录</span>
      </div>
    );
  }

  const displayProjects = maxItems ? projects.slice(0, maxItems) : projects;

  return (
    <div>
      {displayProjects.map(p => (
        <ProjectCard key={p.id} project={p} />
      ))}
    </div>
  );
}
